// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function EnterpriseTextCmp(Props) {
  var class_name = Props.class_name;
  var text_content = Props.text_content;
  return React.createElement("div", {
              className: class_name
            }, text_content);
}

var make = EnterpriseTextCmp;

export {
  make ,
}
/* react Not a pure module */
